module.exports = __webpack_public_path__ + "static/media/Odrudova_skladba.06bd714f.md";